<div class="w-675px privacy-modal">
<db-modal-header-default
  class="header"
  title="{{'FOOTER.' + getAppThemeName() + '.privacy_info.title' | translate}}"
  (close)="onClose()"
>
</db-modal-header-default>

<db-modal-content-default class="content">
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.date' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph1' | translate"></p>

  <h3 class="db-heading-3">{{ 'FOOTER.' + getAppThemeName() + '.privacy_info.subtitle2' | translate }}</h3>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph2.p1' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph2.p2' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph2.p3' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph2.p4' | translate"></p>

  <h3 class="db-heading-3">{{ 'FOOTER.' + getAppThemeName() + '.privacy_info.subtitle3' | translate }}</h3>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph3.p1' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph3.p2' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph3.p3' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph3.p4' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph3.p5' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph3.p6' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph3.p7' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph3.p8' | translate"></p>
  <ul class="db-list--dot db-text">
    <li [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph3.ul.li1' | translate"></li>
    <li [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph3.ul.li2' | translate"></li>
    <li [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph3.ul.li3' | translate"></li>
  </ul>

  <h3 class="db-heading-3">{{ 'FOOTER.' + getAppThemeName() + '.privacy_info.subtitle4' | translate }}</h3>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph4.p1' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph4.p2' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph4.p3' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph4.p4' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph4.p5' | translate"></p>
  <ul class="db-list--dot db-text">
    <li [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph4.ul.li1' | translate"></li>
    <li [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph4.ul.li2' | translate"></li>
    <li [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph4.ul.li3' | translate"></li>
    <li [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph4.ul.li4' | translate"></li>
  </ul>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph4.p6' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph4.p7' | translate"></p>

  <h3 class="db-heading-3">{{ 'FOOTER.' + getAppThemeName() + '.privacy_info.subtitle5' | translate }}</h3>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph5.p1' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph5.p2' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph5.p3' | translate"></p>
  <ul class="db-list--dot db-text">
    <li [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph5.ul.li1' | translate"></li>
    <li [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph5.ul.li2' | translate"></li>
  </ul>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph5.p4' | translate"></p>

  <h3 class="db-heading-3">{{ 'FOOTER.' + getAppThemeName() + '.privacy_info.subtitle6' | translate }}</h3>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph6.p1' | translate"></p>

  <h3 class="db-heading-3">{{ 'FOOTER.' + getAppThemeName() + '.privacy_info.subtitle7' | translate }}</h3>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph7.p1' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph7.p2' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph7.p3' | translate"></p>

  <h3 class="db-heading-3">{{ 'FOOTER.' + getAppThemeName() + '.privacy_info.subtitle8' | translate }}</h3>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph8.p1' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph8.p2' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph8.p3' | translate"></p>

  <h3 class="db-heading-3">{{ 'FOOTER.' + getAppThemeName() + '.privacy_info.subtitle9' | translate }}</h3>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph9.p1' | translate"></p>

  <h3 class="db-heading-3">{{ 'FOOTER.' + getAppThemeName() + '.privacy_info.subtitle10' | translate }}</h3>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p1' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p2' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p3' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p4' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p5' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p6' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p7' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p8' | translate"></p>
  <h5 class="db-heading-3">{{ 'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.h1' | translate }}</h5>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p9' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p10' | translate"></p>
  <h5 class="db-heading-3">{{ 'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.h2' | translate }}</h5>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p11' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p12' | translate"></p>
  <h5 class="db-heading-3">{{ 'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.h3' | translate }}</h5>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p13' | translate"></p>
  <h5 class="db-heading-3">{{ 'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.h4' | translate }}</h5>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p14' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p15' | translate"></p>
  <h5 class="db-heading-3">{{ 'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.h5' | translate }}</h5>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p16' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p17' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p18' | translate"></p>
  <p class="db-text" [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p19' | translate"></p>
  <h5 class="db-heading-3">{{ 'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.h6' | translate }}</h5>
  <p class="db-text"
  [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p20' | translate"></p>
  <p class="db-text"
  [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p21' | translate"></p>
  <p class="db-text"
  [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p22' | translate"></p>
  <p class="db-text"
  [innerHTML]="'FOOTER.' + getAppThemeName() + '.privacy_info.paragraph10.p23' | translate"></p>


</db-modal-content-default>

<db-modal-footer-default class="sticky-bottom p-0" buttonPosition="center">
    <div class="footer justify-content-end">
      <db-button class="mx-3" design="secondary" (click)="onClose()">
        {{ 'FOOTER.' + getAppThemeName() + '.privacy_info.button_1' | translate }}
      </db-button>
      <db-button class="mx-3" design="primary" (click)="onClickDownload()">
        {{ 'FOOTER.' + getAppThemeName() + '.privacy_info.button_2' | translate }}
      </db-button>
    </div>
</db-modal-footer-default>
</div>
